<script setup lang="ts">
interface TagTitleProps {
    icon?: string;
    label: string;
}
defineProps<TagTitleProps>();
</script>
<template>
    <div class="modal-title-tag">
        <i v-if="icon" :class="`ti ti-${icon}`"></i>
        <div>{{ label }}</div>
    </div>
</template>
<style scoped lang="scss">
.modal-title-tag {
    display: flex;
    height: 22px;
    padding: 1px 6px;
    align-items: center;
    gap: 6px;
    border-radius: 4px;
    background: $bg-weak-100;
    color: $text-sub-600;
    white-space: nowrap;
    @include font-size-12;
}
</style>
